import { Site } from '@superbet-group/web.types';

const NapoleonDomain = {
    NapoleonCasino: 'NapoleonCasino',
    NapoleonDice: 'NapoleonDice',
    NapoleonSports: 'NapoleonSports',
} as const;
type NapoleonDomain = typeof NapoleonDomain[keyof typeof NapoleonDomain];

export const siteNapoleonDomainMap: Partial<Record<Site, NapoleonDomain>> = {
    [Site.NapoleonCasino]: NapoleonDomain.NapoleonCasino,
    [Site.NapoleonDice]: NapoleonDomain.NapoleonDice,
    [Site.NapoleonSports]: NapoleonDomain.NapoleonSports,
};
